import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { CacheService } from '../../shared/services/cache.service';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { AuthService } from '../../authentication/services/auth.service';

@Injectable()
export class GlobalAlertService {
  constructor(private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService,
    private cacheService: CacheService,
    private authService: AuthService) {
  }

  public Send(globalalert: any): Observable<any> {
    const currentCultureNameISO = this.authService.getActualLanguage().cultureNameISO;
    const editorialToolsApiUrl = `${APP_SETTINGS.EditorialToolsApiUrl}v1/${currentCultureNameISO}/globalalert`;
    return this.executeService.Execute('post', editorialToolsApiUrl, null, globalalert)
      .pipe(
      catchError(this.errorHandler.handleError('SendGlobalAlert', globalalert))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/editorialtools/services/globalalert.service.ts